export default __webpack_public_path__ + "static/media/OSMOS_CENERE-MATT_60X120_11.7afa53eb.jpg";